
<template>
  <div class="discontinued">
    <slot name="discontinued">暂停销售</slot>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.buy {
  background: rgba(116,179,250,1);
  color: #ffffff;
}
</style>